import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MainLayout } from "@/components/layout/MainLayout";
import { WelcomeHeader } from "@/components/home/WelcomeHeader";
import { HomeGrid } from "@/components/home/HomeGrid";
import { Helmet } from "react-helmet";
import { getUserSettings } from "@/lib/userSettings";

const Index = () => {
  const navigate = useNavigate();

  // Sidebar action handlers (passed from MainLayout)
  const [sidebarActions, setSidebarActions] = useState<{
    onHelp?: () => void;
    onRest?: () => void;
    onClock?: () => void;
    onVolume?: () => void;
  }>({});

  // Check if onboarding is complete
  useEffect(() => {
    const settings = getUserSettings();
    if (!settings.onboardingComplete) {
      navigate("/onboarding");
    }
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>My EyeControl - AAC Communication App</title>
        <meta
          name="description"
          content="My EyeControl is an accessible AAC communication app designed to help people communicate effectively through customizable boards, text-to-speech, and multiple input methods."
        />
      </Helmet>

      <MainLayout
        onSidebarActionsReady={setSidebarActions}
      >
        <div className="flex-1 flex flex-col h-full overflow-hidden">
          {/* Welcome Header - NOT scannable (caregiver controls only) */}
          <WelcomeHeader />

          {/* Main Content Area - fits viewport without scroll */}
          <div className="flex-1 flex items-center justify-center p-2 min-h-0 h-full">
            <HomeGrid
              onHelp={sidebarActions.onHelp}
            />
          </div>

        </div>
      </MainLayout>
    </>
  );
};

export default Index;
